import SeasonalPaywall, {
  SeasonalPaywallColors,
} from "../SeasonalPaywall/SeasonalPaywall"
import svg from "../../utils/svg"
import styles from "./AutumnPaywall.module.scss"
import useStrings from "../../localization/useStrings"

const autumnColors: SeasonalPaywallColors = {
  scrollableGradient:
    "linear-gradient(to bottom, #FFE9CA 0%, #FFE9CA 20%, #FE9448 80%, #FE9448 100%)",
  header: {
    background: "#FF9448",
    title: "#B92E3D",
    tagline: "#30343D",
  },
  countdown: {
    boxBackground: "#FFE2BC",
    value: "#30343D",
    unit: "#6D260B",
    label: "#6D260B",
  },
  content: {
    background: "#FF9448",
    ultimateContainerBackground: "#9C4A24",
    ultimateContainerText: "white",
  },
  features: {
    icon: "#9C4A24",
    title: "#6D260B",
    description: "#9C4A24",
  },
  footer: {
    background: "#FF9448",
    primaryButton: {
      background: "#45111E",
      headerBackground: "#45111E",
      contentBackground: "#FFE2BC",
      limitedTimeText: "#FFE2BC",
      saveTagText: "#FFE2BC",
      planTitle: "#30343D",
      duration: "#65686E",
      originalPrice: "#65686E",
      discountedPrice: "#30343D",
      monthlyRate: "#30343D",
    },
    monthlyButton: {
      background: "#FFE2BC",
      border: "1px solid #E5E5E5",
      label: "#30343D",
      price: "#30343D",
    },
  },
  insets: {
    header: "#FFE9CA",
    footer: "#FFE2BC",
  },
}

const AutumnPaywall = () => {
  const strings = useStrings()

  return (
    <SeasonalPaywall
      headerSpacing="-20px"
      topDecoration={
        <div className={styles.top}>
          <svg.autumn.Top />
          <div className={styles.topBackground}></div>
        </div>
      }
      footerBackground={
        <div className={styles.bottom}>
          <svg.autumn.Bottom />
        </div>
      }
      colors={autumnColors}
      strings={{
        title: strings.autumnSale.title,
        tagline: strings.autumnSale.tagline,
        buttonTitle: strings.autumnSale.buttonTitle,
      }}
    />
  )
}

export default AutumnPaywall
